import React, { useState, useEffect, useRef } from 'react';

const CountdownTimer = ({ expiryTime, onExpire }) => {
  const [timeLeft, setTimeLeft] = useState(null);
  const [isExpired, setIsExpired] = useState(false);
  const hasExpiredRef = useRef(false);

  useEffect(() => {
    if (!expiryTime) return;

    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const expiry = new Date(expiryTime).getTime();
      const difference = expiry - now;

      if (difference > 0) {
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        return {
          hours: hours.toString().padStart(2, '0'),
          minutes: minutes.toString().padStart(2, '0'),
          seconds: seconds.toString().padStart(2, '0'),
          total: difference
        };
      } else {
        return null;
      }
    };

    const updateTimer = () => {
      const timeLeft = calculateTimeLeft();
      
      if (timeLeft) {
        setTimeLeft(timeLeft);
        setIsExpired(false);
        hasExpiredRef.current = false;
      } else {
        setTimeLeft(null);
        setIsExpired(true);
        
        // Only call onExpire once
        if (!hasExpiredRef.current && onExpire) {
          hasExpiredRef.current = true;
          onExpire();
        }
      }
    };

    // Update immediately
    updateTimer();

    // Set up interval
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [expiryTime, onExpire]);

  if (!expiryTime || isExpired) {
    return (
      <span className="text-danger fontweight700">
        <i className="fas fa-exclamation-triangle me-1"></i>
        Expired
      </span>
    );
  }

  if (!timeLeft) {
    return (
      <span className="text-muted">
        <i className="fas fa-clock me-1"></i>
        Calculating...
      </span>
    );
  }

  const isUrgent = timeLeft.total < 5 * 60 * 1000; // Less than 5 minutes

  return (
    <span className={`fontweight700 ${isUrgent ? 'text-danger' : 'text-warning'}`}>
      <i className="fas fa-clock me-1"></i>
      {timeLeft.hours}:{timeLeft.minutes}:{timeLeft.seconds}
      {isUrgent && <small className="ms-1">(Urgent!)</small>}
    </span>
  );
};

export default CountdownTimer;
